import { useContext } from 'react';
import { MessageContext, MessageContextType } from '@/contexts/message/MessageContext';

export function useMessage(): MessageContextType {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
  return context;
}